import { isString } from "@/utils"

export const getAvailableOptions = data => {
  const { availableOptions = {}, option = "", field = "" } = data
  return !availableOptions[field]?.includes(option)
}

export const formatFacetName = data => {
  const { field = "", facetLabels = {} } = data
  if (facetLabels && facetLabels[field]) {
    return facetLabels[field]
  }
  return field.replace(/\./g, "/").replace(/_/g, " ")
}

export const checkFacetData = facet => {
  return facet && facet[0] && facet[1] && facet[1].length
}

const isMatchWithCurrent = data => {
  const { obj, currOptions, currentKey, optionKeys } = data
  const isData = []
  Object.entries(obj).forEach(([key, val]) => {
    if (optionKeys.includes(key) && key !== currentKey) {
      isData.push(currOptions[key] === val)
    }
  })

  return !isData.includes(false)
}

export const getAvailableOptionsFields = (data = {}) => {
  const {
    options: optionsObjData = {},
    currOptions = {},
    variantOptions = [],
  } = data

  const excludeCurrent = variantOptions

  const options = Object.fromEntries(
    Object.entries(optionsObjData).map(([key, val]) => [
      key,
      val.filter(e => isString(e)),
    ])
  )
  const optionKeys = Object.keys(options)

  const removeValue = {}

  Object.entries(options).forEach(([key, values = []]) => {
    values.forEach(el => {
      const isExit = currOptions[key] === el
      if (!isExit) {
        const exData = excludeCurrent.filter(e => e[key] === el)

        exData.forEach(obj => {
          const isMatched = isMatchWithCurrent({
            obj,
            currOptions,
            currentKey: key,
            optionKeys,
          })

          Object.entries(obj).forEach(([objKey, objVal]) => {
            if (optionKeys.includes(objKey)) {
              if (isMatched || currOptions[objKey] === objVal) {
                if (removeValue[objKey]) {
                  removeValue[objKey].push(objVal)
                } else {
                  removeValue[objKey] = [objVal]
                }
              }
            }
          })
        })
      }
    })
  })

  return removeValue
}
